import axios from "axios"

const api = axios.create({
  baseURL: "/api/v1",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
})

// Auth endpoints that should never carry an existing JWT
const AUTH_PATHS = ["/users/sign_in", "/users/sign_up", "/users/passwords"]

// Attach JWT token from localStorage to every non-auth request
api.interceptors.request.use((config) => {
  const isAuthEndpoint = AUTH_PATHS.some((p) => config.url?.includes(p))
  if (!isAuthEndpoint) {
    const token = localStorage.getItem("token")
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// On 401, clear token and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token")
      localStorage.removeItem("user")
      if (window.location.pathname !== "/login") {
        window.location.href = "/login"
      }
    }
    return Promise.reject(error)
  },
)

export default api
